import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';

import SoftCardPRank from '../../components/SoftCardPRank/SoftCardPRank';
import { CONTEXT } from '../../config';
import styles from './ThreeColumnRank.module.less';
import { cleanSearchRecommend } from '../../actions/search';
import { logging, logPostInfo } from '../../actions/log';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(cardData => {
  const { data = {}, logInfo } = cardData;
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);

  const showSize = 5;
  const LOG_ACTION_SOURCE = {
    c_more: `${logInfo.tag}_Rank_More`,
    source: `${logInfo.tag}_Rank`,
    source_app: `${logInfo.tag}_Rank`,
  };

  const [ref, inView] = useInView({
    threshold: 1,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
        rankCode: data && data.dataList && data.dataList[0] && data.dataList[0].code,
        cardType: data && data.cardType,
      });
    }
  }, [inView]);

  const handleShowMore = useCallback(
    rankData => {
      // 推荐页面banner点击打桩
      dispatch(
        logging({
          category: 'C',
          action: LOG_ACTION_SOURCE.c_more,
          label: '',
          param2: {
            source: `${LOG_ACTION_SOURCE.source}||${rankData.code}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      dispatch(
        logPostInfo({
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
        }),
      );
      history.push(`${CONTEXT}/rankmore?code=${rankData.code}`);
      dispatch(cleanSearchRecommend());
    },
    [dispatch, logInfoData],
  );

  return (
    (data.dataList && data.dataList.length > 2 && (
      <div className={styles.card} ref={ref}>
        {data.dataList.map((item, index) => {
          return (
            <div className={styles.card_column} key={index}>
              <div className={`${styles[`card_header${index + 1}`]}`}>
                <div className={styles.card_header_title}>{item.name}</div>

                {item.apps.length > 5 && (
                  <div
                    className={styles.card_header_more}
                    onClick={() => {
                      handleShowMore(item);
                    }}
                  >
                    更多
                  </div>
                )}
              </div>
              <div className={styles.content_column}>
                {item.apps.slice(0, showSize).map((soft, i) => (
                  <SoftCardPRank
                    soft={{ ...soft, cardShowDesc: true }}
                    logInfo={{
                      ...logInfo,
                      source: `${LOG_ACTION_SOURCE.source_app}||${item.code}`,
                    }}
                    key={i}
                    index={i + 1}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    )) ||
    null
  );
});
